import React from 'react';
import ScanToCadHero from '../../../components/service/ScanToCadHero';
import QuoteForm from '../../../components/home/QuoteForm';
import ServiceTrusted from '../../../components/service/ServiceTrusted';
import ScanToCad4 from '../../../components/service/ScanToCad4';
import ScanToCad5 from '../../../components/service/ScanToCad5';
import DesireTechSection from '../../../components/home/DesireTechSection';
import OnboardingSection from '../../../components/home/OnboardingSection';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import ServiceChoose from '../../../components/service/ServiceChoose';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import AwardsSection from '../../../components/home/AwardsSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';
import processIcon from '../../../assets/img/OnboardingSection/1.png';

const ScanToCadPage = () => {
  return (
    <div className="scan-to-cad-page">
      <ScanToCadHero />
      <QuoteForm />
      <ServiceTrusted
        title={<><span className="text-primary">Professional Scan to CAD Services for</span> Architects, Engineers, and Contractors</>}
        paragraphs={[
          "Our Scan to CAD services help architects, engineers, contractors, surveyors, and facility teams convert laser scan and point cloud data into accurate, editable CAD drawings. Whether you need as-built floor plans for an existing building, elevation drawings for renovation planning, or detailed sections from point cloud data, our team delivers structured CAD outputs ready for design, documentation, and coordination.",
          "We support a wide range of USA projects, including residential properties, commercial buildings, industrial facilities, retail spaces, offices, and renovation sites. From point cloud to CAD services to full as-built CAD drawings, we create organized deliverables in DWG and PDF formats with focus on clarity, consistency, and quick turnaround."
        ]}
        buttonText="Request a Scan to CAD Quote"
      />
      <ScanToCad4 />
      <ScanToCad5 />
      <DesireTechSection
        title={<><span className="text-primary">Ready to Convert Your</span> Scan Data into CAD?</>}
        subtitle="Get high-quality CAD drawings delivered fast and at competitive pricing."
        buttonText="Get Your Free Quote Today"
      />
      <OnboardingSection
        title={<><span className="text-primary">Our Process (Very</span> Important for Conversion)<span className="text-primary"></span></>}
        description="We follow a structured workflow designed for precision and accuracy. We are dedicated to delivering as-built models that are not only dependable but also perfectly suited for real-world applications."
        buttonText="Choose Your Model"
        steps={[
          {
            step: "Step 1",
            title: "Upload Your Scan Data",
            desc: "Send us your point cloud / laser scan files",
            icon: processIcon
          },
          {
            step: "Step 2",
            title: "Get a Quick Quote",
            desc: "We analyze and provide pricing within 24 hours",
            icon: processIcon
          },
          {
            step: "Step 3",
            title: "CAD Drafting Begins",
            desc: "Our experts convert your data into accurate drawings",
            icon: processIcon
          },
          {
            step: "Step 4",
            title: "Quality Check",
            desc: "Multi-level QA ensures 100% accuracy",
            icon: processIcon
          },
          {
            step: "Step 5",
            title: "Final Delivery",
            desc: "Receive ready-to-use CAD files on time",
            icon: processIcon
          }
        ]}
      />
      <ProjectsSection />
      <TestimonialsSection />
      <ServiceChoose
        title={<> <span className="text-primary">How to Choose the Right MEP BIM Services</span> Company for Your Building & Construction Projects</>}
        subtitle="The benefits of MEP BIM Services in the construction process are numerous. Here are the key advantages of MEP coordination, clash detection, and shop drawing outsourcing."
        points={[
          {
            title: "MEP BIM Expertise",
            desc: "Our MEP BIM models are delivered by experienced engineers skilled in Autodesk Revit MEP, Navisworks, and industry-standard coordination workflows."
          },
          {
            title: "Clash-Free Coordination",
            desc: "We provide accurate MEP clash detection and coordination, eliminating conflicts between Mechanical, Electrical, & Plumbing systems before construction begins."
          },
          {
            title: "Focus on Core Work",
            desc: "Leave the complexity of MEP BIM modeling to our experts while your team focuses on design decisions, client management, and on-site execution."
          },
          {
            title: "Latest BIM Technology",
            desc: "We use the latest Autodesk Revit MEP, AutoCAD MEP, and Navisworks software to deliver high-performance models with maximum accuracy and LOD compliance."
          },
          {
            title: "Scalable for Any Project",
            desc: "Our MEP BIM services scale seamlessly from small residential fit-outs to large commercial, industrial, and infrastructure projects of any size and complexity."
          },
          {
            title: "Seamless Collaboration",
            desc: "Our team works as a direct extension of yours — coordinating with architects, structural engineers, contractors, and all MEP stakeholders for smooth project delivery."
          },
          {
            title: "Faster Turnaround",
            desc: "Our turnaround time for MEP BIM projects is faster with the help of advanced tools, streamlined workflows, and dedicated project managers who help meet your deadlines."
          },
          {
            title: "Global Reach",
            desc: "We serve clients across the USA, UK, UAE, Canada, and Australia, delivering MEP BIM services with full compliance to international standards and project requirements."
          }
        ]}
      />
      <BestArchitectureSection />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection
        title={<><span className="text-primary">Frequently Asked</span> Questions</>}
        faqs={[
          {
            question: "What Is The Difference Between Laser Scanning And BIM Modeling?",
            answer: "Laser scanning is the process of capturing high-accuracy 3D data of a physical space, while BIM modeling is the process of converting that raw data (point clouds) into intelligent, 3D parametric models containing comprehensive building information."
          },
          {
            question: "What File Formats Do You Accept For Point Cloud Modeling?",
            answer: "We accept all major raw laser scan formats, including E57, RCP, RCS, PTX, FARO (FLS), Leica, and Z+F files. Our team can work with data from most professional-grade 3D scanners."
          },
          {
            question: "Can You Create Revit Models From Laser Scan Data?",
            answer: "Yes, our primary expertise is converting point cloud data into high-quality Autodesk Revit models. We create detailed architectural, structural, and MEP models from laser scan data with high precision."
          },
          {
            question: "What Level Of Detail Can You Provide?",
            answer: "We provide BIM modeling services up to LOD 500. Whether you need a simple LOD 100 conceptual model for initial planning or a detailed LOD 400 fabrication model, we tailor our output to your project's specific needs."
          },
          {
            question: "Is Laser Scan To BIM Useful For Old Buildings?",
            answer: "Absolutely. Scan to BIM is especially valuable for heritage and older buildings where original drawings are missing or inaccurate. It provides a precise as-built record of the existing conditions, which is essential for renovations."
          },
          {
            question: "Do You Provide As-Built Drawings Also?",
            answer: "Yes, in addition to 3D models, we can extract 2D CAD as-built drawings, including floor plans, elevations, sections, and site plans directly from the point cloud data or the developed BIM model."
          }
        ]}
      />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default ScanToCadPage;
